import { render, staticRenderFns } from "./VChart.vue?vue&type=template&id=4ee5c1da&"
import script from "./VChart.vue?vue&type=script&lang=js&"
export * from "./VChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports